<template>
	<div class="element element--progress">
		<div class="element__progress">
			<div
				v-if="touched"
				class="element__progress__scrub"
				role="progressbar"
				:aria-valuemin="min"
				@touchmove="processTouchMove"
				@touchdown="processEvent"
				@mousedown="processEvent"
				@mousemove="processEvent"
				:aria-valuemax="max"
				:aria-valuenow="value"
				:aria-valuetext="ariaText"
			></div>
			<div class="element__progress__bar" :style="width"></div>
		</div>
		<time
			v-if="typeof pastTime !== 'undefined'"
			class="element__progress__time element__progress__time--pastTime"
			aria-hidden="true"
			>{{ readAbleTime(pastTime) }}</time
		>
		<time
			v-if="typeof remainingTime !== 'undefined'"
			class="element__progress__time element__progress__time--remainingTime"
			aria-hidden="true"
			>{{ readAbleTime(remainingTime) }}</time
		>
		<time
			v-if="typeof duration !== 'undefined'"
			class="element__progress__time element__progress__time--duration"
			aria-hidden="true"
			>{{ readAbleTime(duration) }}</time
		>
		<time
			v-if="typeof duration !== 'undefined' && typeof pastTime !== 'undefined'"
			class="element__progress__time element__progress__time--fracture"
			aria-hidden="true"
			>{{ readAbleTime(pastTime) }}/{{ readAbleTime(duration) }}</time
		>
	</div>
</template>

<script>
import { detectLeftButton, isIOS } from '../../tools/helpers';
import { returnReadableTime } from '../../tools/helpers';
export default {
	data() {
		return {
			classList: '',
		};
	},
	props: {
		progress: Number,
		touched: Function,
		min: Number,
		max: Number,
		value: Number,
		unit: String,
		duration: Number,
		pastTime: Number,
		remainingTime: Number,
	},
	computed: {
		width() {
			const percent = this.progress * 100;
			/* eslint-disable no-nested-ternary */
			return `width:${percent > 100 ? 100 : percent < 0 ? 0 : percent}%`;
		},
		ariaText() {
			return `${this.value} ${this.unit}`;
		},
		hasPastTime() {
			return typeof pastTime !== 'undefined';
		},
	},
	methods: {
		readAbleTime(time) {
			return returnReadableTime(time);
		},
		processTouchMove(event) {
			event.preventDefault();
			event.stopPropagation();
			event.returnValue = false;
			const rect = event.target.getBoundingClientRect();
			const x = event.targetTouches[0].clientX - rect.left; // x position within the element.
			const y = event.targetTouches[0].clientY - rect.top; // y position within the element.
			this.touched(x / (rect.right - rect.left), y / (rect.bottom - rect.top));
		},
		processEvent(event) {
			if (detectLeftButton(event) || isIOS()) {
				event.preventDefault();
				event.stopPropagation();
				event.returnValue = false;
				const rect = event.target.getBoundingClientRect();
				const x = event.clientX - rect.left; // x position within the element.
				const y = event.clientY - rect.top; // y position within the element.
				this.touched(x / (rect.right - rect.left), y / (rect.bottom - rect.top));
			}
		},
	},
};
</script>

<style></style>
